export const Compatibility = {
  MOGRT: 1,
  AfterEffects: 2,
  PremierePro: 3,
  DaVinciResolve: 4,
  DragAndDrop: 5,
  FinalCut: 6,
} as const;

export type CompatibilityType =
  (typeof Compatibility)[keyof typeof Compatibility];
